import numeral from 'numeral'
import dayjs from 'dayjs'
import TooltipTicker from 'core/TickerOverlay/TickerOverlay'

export const confirmedColumns = [
  {
    Header: '',
    accessor: 'filingDate',
    width: 'fit-content',
    disableGroupBy: true,
    Cell: Cell => {
      return ''
    },
  },

  {
    Header: 'Symbol',
    accessor: 'symbol',
    width: 'fit-content',
    disableGroupBy: true,
    Search: true,
    Cell: Cell => {
      return <TooltipTicker ticker={Cell.value} />
    },
  },
  {
    Header: 'Form',
    accessor: 'form',
    width: 'fit-content',
    disableGroupBy: true,
  },
  {
    Header: 'Accepted Date',
    accessor: 'acceptedDate',
    width: 'fit-content',
    disableGroupBy: true,
    Cell: ({ value }) => dayjs(value).format('MMMM D, YYYY'),
  },
  {
    Header: 'Effectiveness Date',
    accessor: 'effectivenessDate',
    width: 'fit-content',
    disableGroupBy: true,
    Cell: ({ value }) => dayjs(value).format('MMMM D, YYYY'),
  },
]
